export default __webpack_public_path__ + "static/media/Community.dbf6f140.png";